module.exports = __webpack_public_path__ + "img/B-title-02.ec10934f.png";